export type CountryCode = 'ES' | 'US' | 'MX' | 'CO' | 'CL' | 'PE'

export type CountryConfig = {
  code: CountryCode
  name: string
  currency: string
  symbol: string
  locale: string
  decimals: 0 | 2
  symbolAfter?: boolean
}

export const COUNTRIES: CountryConfig[] = [
  {
    code: 'ES',
    name: 'España',
    currency: 'EUR',
    symbol: '€',
    locale: 'es-ES',
    decimals: 2,
    symbolAfter: true,
  },
  {
    code: 'US',
    name: 'Estados Unidos',
    currency: 'USD',
    symbol: '$',
    locale: 'en-US',
    decimals: 2,
  },
  {
    code: 'MX',
    name: 'México',
    currency: 'MXN',
    symbol: '$',
    locale: 'es-MX',
    decimals: 2,
  },
  {
    code: 'CO',
    name: 'Colombia',
    currency: 'COP',
    symbol: '$',
    locale: 'es-CO',
    decimals: 0,
  },
  {
    code: 'CL',
    name: 'Chile',
    currency: 'CLP',
    symbol: '$',
    locale: 'es-CL',
    decimals: 0,
  },
  {
    code: 'PE',
    name: 'Perú',
    currency: 'PEN',
    symbol: 'S/',
    locale: 'es-PE',
    decimals: 2,
  },
]

export const DEFAULT_COUNTRY: CountryCode = 'ES'

export const FALLBACK_RATES: Record<string, number> = {
  EUR: 1,
  USD: 1.09,
  MXN: 19.8,
  COP: 4350,
  CLP: 1030,
  PEN: 4.05,
}

export function getCountryConfig(code: CountryCode): CountryConfig {
  return COUNTRIES.find((country) => country.code === code) ?? COUNTRIES[0]
}

export function isSupportedCountry(value: string): value is CountryCode {
  return COUNTRIES.some((country) => country.code === value)
}
